import React from "react";
import { Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Dale M.",
    location: "Calgary → Halifax",
    vehicle: "Class A Motorhome",
    text: "Picked up in Calgary on the promised morning, delivered to Halifax spotless. Same driver the entire way. Felt like a handshake deal from start to finish.",
  },
  {
    name: "Jasmine R.",
    location: "Victoria → Toronto",
    vehicle: "Harley Road Glide",
    text: "I've shipped bikes three times with brokers — this was a completely different experience. Enclosed trailer, photos at every stop, zero scratches.",
  },
  {
    name: "Frédéric L.",
    location: "Québec → Whitehorse",
    vehicle: "Ski-Doo Summit + trailer",
    text: "They took on the run nobody else would, in January. Locked price, pro tie-down, honest ETA. These folks don't play games.",
  },
  {
    name: "Karen B.",
    location: "Winnipeg → Kelowna",
    vehicle: "Campion bowrider",
    text: "The quote was clear and in Canadian dollars with no hidden fees. Matt suggested I shrink-wrap the boat before pickup to keep dirt and weather off during the long haul, which was a great call. The driver even gave it a quick wash before delivery. Landed in Kelowna in great shape and ready for the water.",
  },
  {
    name: "Mike D.",
    location: "Edmonton → Regina",
    vehicle: "Polaris RZR side-by-side",
    text: "Quoted Monday, on the truck Tuesday, in my driveway Thursday morning. I have never seen a hauling company move this fast. Efficient does not begin to cover it.",
  },
  {
    name: "Anita P.",
    location: "Calgary → Vancouver",
    vehicle: "Travel trailer 26 ft",
    text: "Booked on short notice for a posting move. Dispatch called me back inside 20 minutes with a firm price, and the trailer was gone the next day. Speed and clarity — exactly what I needed.",
  },
  {
    name: "Rob T.",
    location: "Saskatoon → Thunder Bay",
    vehicle: "Fifth-wheel trailer",
    text: "Blizzard rolled through the corridor and my driver held the load an extra day at a safe stop instead of pushing it. Kept me updated the whole time. When the highway reopened they were back on the road and my trailer landed without a scratch. Right call every time — safety over schedule.",
  },
  {
    name: "Chantal G.",
    location: "Montréal → Halifax",
    vehicle: "Kawasaki Ninja 650",
    text: "Enclosed transport, cross-province in 48 hours, and a driver who actually answered his phone. No broker runaround, no delays. Best shipping experience I have had, period.",
  },
  {
    name: "Kirk P.",
    location: "Edmonton → Ottawa",
    vehicle: "Side-by-Side",
    text: "Requested on Tuesday, picked up Friday, and delivered within 3 days. Excellent service! Highly, highly recommend Matt and his team.",
  },
  {
    name: "RV World",
    location: "AYR OpenLane Auctions → Acheson, AB",
    vehicle: "42 ft & 36 ft fifth wheels",
    text: "Matt's team picked up a 42-foot fifth wheel and a 36-foot fifth wheel for us straight from AYR OpenLane Auctions and had both units on our lot in Acheson the same week. That kind of turnaround on oversized loads is rare in this industry. They're the direct carrier we rely on for dealer inventory moves.",
  },
  {
    name: "Trevor W.",
    location: "Grande Prairie → London, ON",
    vehicle: "Ducati Multistrada",
    text: "Initial pickup got pushed back a day because of a driver reroute, and I'll admit I was nervous. Matt personally called me, explained everything, and comped an upgrade to enclosed. Bike arrived a full day earlier than the new ETA, spotless. Started rocky, ended up as the best shipping experience I've had.",
  },
  {
    name: "Sandra & Paul H.",
    location: "Kelowna → Fredericton",
    vehicle: "34 ft travel trailer",
    text: "First quote we got felt too good — we assumed something was off. Then a scheduling mix-up delayed the pickup window. Dispatch owned the mistake immediately, held the original price, and got a driver on the road within 48 hours. The trailer landed in Fredericton faster than the revised ETA. These folks don't run from problems, they fix them.",
  },
  {
    name: "Devin R.",
    location: "Calgary → Sault Ste. Marie",
    vehicle: "Can-Am Maverick X3",
    text: "Original quote had the wrong distance calc and came in higher than expected on the invoice. I flagged it, Matt reviewed the run himself and honored the original quote without argument. The Maverick arrived earlier than promised. Honest company that stands behind their word — hard to find in this business.",
  },
  {
    name: "Marcus O.",
    location: "Winnipeg → St. Albert, AB",
    vehicle: "Polaris Indy XC",
    text: "Storm hit the prairies right after pickup and I was sure my sled was stuck in a truck stop for a week. Driver called me every day with updates, waited out the worst of it safely, and rolled into St. Albert on the very next clear day. Machine came off the trailer in better shape than it went on. Rocky forecast, five-star handling.",
  },
  {
    name: "Lisa K.",
    location: "Barrie, ON → Sylvan Lake, AB",
    vehicle: "Bayliner 235 cuddy",
    text: "At pickup my trailer had a bad wheel bearing and I panicked — thought the whole booking would fall apart. The driver called ahead, sourced a replacement in the next town, expensed it, and kept going. Boat landed on my lift in Sylvan Lake three days later. They saved my summer.",
  },
  {
    name: "Curtis N.",
    location: "Regina → Kamloops",
    vehicle: "36 ft fifth wheel",
    text: "Left tail light was cracked at pickup — not caused by them, but they wouldn't roll until it was safe. Driver hit a parts store, replaced the light himself, and still delivered on the original day. That's the kind of care you don't get from a broker chain. Started with a headache, ended up impressed.",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-[#F4F4F1] border-b-2 border-[#122A1E]" data-testid="testimonials-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-6 mb-12">
          <div>
            <div className="font-mono-accent text-[11px] uppercase text-[#4A5550] mb-3">
              ◆ 004 · Reviews
            </div>
            <h2 className="font-display font-black uppercase tracking-tighter leading-none text-[#0A0E0C] text-4xl md:text-5xl">
              Owners Talk.
              <br />
              We Listen.
            </h2>
          </div>
          <div className="flex items-center gap-3 border-2 border-[#122A1E] px-4 py-3 bg-[#F4F4F1]">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={16} className="fill-[#FF5A00] text-[#FF5A00]" />
              ))}
            </div>
            <div>
              <div className="font-display font-black text-lg">4.9 / 5</div>
              <div className="font-mono-accent text-[9px] uppercase text-[#4A5550]">
                1,200+ Canadian Owners
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          {REVIEWS.map((r, i) => (
            <figure
              key={i}
              className="border-2 border-[#122A1E] bg-[#EAEAE5] p-7 hover-lift"
              data-testid={`review-${i}`}
            >
              <div className="flex gap-1 mb-3">
                {[...Array(5)].map((_, si) => (
                  <Star key={si} size={14} className="fill-[#FF5A00] text-[#FF5A00]" />
                ))}
              </div>
              <blockquote className="font-body text-[#0A0E0C] text-base md:text-lg leading-relaxed">
                "{r.text}"
              </blockquote>
              <figcaption className="mt-5 pt-5 border-t-2 border-[#D2CEBD] flex items-baseline justify-between">
                <div>
                  <div className="font-display font-bold uppercase text-[#0A0E0C]">{r.name}</div>
                  <div className="font-mono-accent text-[10px] uppercase text-[#4A5550]">{r.location}</div>
                </div>
                <div className="font-mono-accent text-[10px] uppercase text-[#FF5A00]">{r.vehicle}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
